// frontend/src/actions/developerActions.js
import axios from "../utilities/axiosInstance";
import {
  DEVELOPER_CREATE_REQUEST,
  DEVELOPER_CREATE_SUCCESS,
  DEVELOPER_CREATE_FAIL,
  DEVELOPER_UPDATE_REQUEST,
  DEVELOPER_UPDATE_SUCCESS,
  DEVELOPER_UPDATE_FAIL,
  DEVELOPER_DELETE_REQUEST,
  DEVELOPER_DELETE_SUCCESS,
  DEVELOPER_DELETE_FAIL,
  DEVELOPER_DETAILS_REQUEST,
  DEVELOPER_DETAILS_SUCCESS,
  DEVELOPER_DETAILS_FAIL,
} from "../constants/developerConstants";

// 1) CREATE
export const createDeveloper =
  (name, email, password) => async (dispatch, getState) => {
    try {
      dispatch({ type: DEVELOPER_CREATE_REQUEST });
      console.log("Creating a new developer with role: developer");

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo?.token}`,
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        "/users/register", // or your route
        { name, email, password, role: "developer" },
        config
      );

      console.log("Developer creation success:", data);
      dispatch({ type: DEVELOPER_CREATE_SUCCESS, payload: data });
    } catch (error) {
      console.error("Error creating developer:", error);
      dispatch({
        type: DEVELOPER_CREATE_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

// 2) UPDATE
export const updateDeveloper =
  (developerId, updates) => async (dispatch, getState) => {
    try {
      dispatch({ type: DEVELOPER_UPDATE_REQUEST });
      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
          "Content-Type": "application/json",
        },
      };

      // updates = { name, email, password? }
      const { data } = await axios.put(
        `/users/${developerId}`,
        updates,
        config
      );

      dispatch({ type: DEVELOPER_UPDATE_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: DEVELOPER_UPDATE_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

// 3) DELETE
export const deleteDeveloper = (developerId) => async (dispatch, getState) => {
  try {
    dispatch({ type: DEVELOPER_DELETE_REQUEST });
    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: { Authorization: `Bearer ${userInfo.token}` },
    };

    const { data } = await axios.delete(`/users/${developerId}`, config);
    dispatch({ type: DEVELOPER_DELETE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: DEVELOPER_DELETE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// 4) GET SINGLE DEVELOPER
export const getSingleDeveloper =
  (developerId) => async (dispatch, getState) => {
    try {
      dispatch({ type: DEVELOPER_DETAILS_REQUEST });
      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: { Authorization: `Bearer ${userInfo?.token}` },
      };

      // Suppose the route is GET /users/developer/:id
      // or GET /users/:id with role check
      const { data } = await axios.get(
        `/users/developer/${developerId}`,
        config
      );

      dispatch({ type: DEVELOPER_DETAILS_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: DEVELOPER_DETAILS_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };
